import React from 'react';

import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { profile as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    profileDetailsConfig: {
      getTitleText: (isMobileMq) => (isMobileMq ? <>Profile</> : <>My profile</>),
      getLinkText: () => <>Edit profile</>,
      editLinkUrl: '',
      programName: '',
    },
    emailDetailsConfig: {
      getTitleText: () => <>Email and alerts</>,
      getButtonText: () => <>Edit email settings</>,
      getSubscribedText: (brandDisplayName) => <>You are currently opted-in to all {brandDisplayName} emails.</>,
      getUnsubscribedText: (brandDisplayName) => <>You are currently opted out from {brandDisplayName}.</>,
      checkIsSubscribed: (subscriptions) => {
        const relevantSubscriptions = ['email_news_optin', 'email_odotw_optin', 'email_solo_optin'];
        return relevantSubscriptions.some((key) => subscriptions[key]);
      },
      shouldShowFavoritesDetails: true,
    },
    accountSnapshotConfig: {
      getUserInfoText: (userName) => (<>Member: {userName}</>),
      getRegistrationDateText: (isMobileMQ, formattedCreateDate) => (
        <>Member since <span className="mn_noWrap">{formattedCreateDate}</span></>
      ),
    },
    recentActivityConfig: {
      recentTransactionsTabTitle: 'Recent transactions',
      recentStoreVisitsTabTitle: 'Recent store visits',
      inStoreActivityTabTitle: 'In store activity',
    },
    shouldShowInstoreDetails: true,
    favoritesDetailsConfig: {
      customExtraLabel: 'extra',
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
